import { Migration } from "@mydocma/core/src/lib/migration";
import { IDBPDatabase } from "idb";
import { MmProjectDbCollections } from "../../mm-project-db-schema";

export const V4: Migration = {

  up(database: IDBPDatabase<unknown>) {

    const store = database.createObjectStore(MmProjectDbCollections.fault_patches,  { keyPath: 'operation.id' });
    store.createIndex('fUid', 'fUid', { unique: false});
    database.createObjectStore(MmProjectDbCollections.sync_files, { keyPath: 'uid' });
  },

};
